// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"670":"2e0acb50","754":"f9b2d48d"}[chunkId] + ".chunk.css";
};